import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategoryNav() {
  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-2">
            漫画分类
          </h2>
          <p className="text-sm text-foreground-500">探索你喜欢的漫画类型，发现更多精彩作品</p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.id}`}
              className="group flex items-center gap-3 p-4 bg-background-100 rounded-lg hover:bg-background-200/70 transition-colors cursor-pointer"
            >
              <span className={`w-10 h-10 md:w-11 md:h-11 flex items-center justify-center rounded-lg ${cat.color} transition-transform group-hover:scale-110`}>
                <i className={`${cat.icon} text-base md:text-lg`}></i>
              </span>
              <span className="text-sm font-medium text-foreground-800 whitespace-nowrap">{cat.name}</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}